import React, { useContext } from 'react'

import { CompanyTypes } from 'EstraSuppliers'
import { AuthenticationContext } from 'app/Contexts/AuthenticationProvider'
import { FormGrid } from 'app/components/shared/FormGrid'
import { Text } from 'app/components/ui/Text'
import { Tooltip } from 'app/components/ui/Tooltip'
import { themeEstra } from 'app/styles/themeEstra'
import { SmartInput } from 'app/components/formik/Input'
import { SmartRadio } from 'app/components/formik/Radio'
import { FormGroup } from 'app/components/shared/FormGroup'
import InfoIcon from 'static/icons/info.svg'
import styled from 'styled-components'
import { SmartDatePicker } from 'app/components/formik/DatePicker'

const companyTypes: {
  [key in CompanyTypes]: string
} = {
  individuale: 'Ditta individuale',
  snc: 'Snc',
  srl: 'Srl',
  sas: 'Sas',
  spa: 'Spa',
  sapa: 'Sapa',
  cooperativa: 'Cooperativa',
  scs: 'Scs',
  srlu: 'Srlu',
  ss: 'Ss',
  ati: 'Ati',
  ente: 'Ente',
  associazione: 'Associazione',
  fondazione: 'Fondazione',
  consorzio: 'Consorzio',
  onlus: 'Onlus',
  privato: 'Privato',
}

export const Company: React.FC = () => {
  const authCtx = useContext(AuthenticationContext)
  const showCompanyVat = Boolean(
    authCtx && authCtx.actor?.supplier.registration_type === 'company'
  )

  return (
    <>
      <FormGrid cols={[8, 4]}>
        <SmartInput
          label='Ragione sociale'
          name='company_name'
          required
        ></SmartInput>
        <SmartInput
          label='Forma giuridica'
          name='company_type'
          type='select'
          required
          selectCaretSize='small'
        >
          <option value={''}>Seleziona</option>
          {Object.keys(companyTypes).map(optValue => (
            <option key={optValue} value={optValue}>
              {companyTypes[optValue as CompanyTypes]}
            </option>
          ))}
        </SmartInput>
      </FormGrid>

      <FormGrid cols={[4, 4, 4]}>
        <SmartInput
          label='Codice Fiscale'
          name='company_fiscal_code'
          required
        />
        {showCompanyVat && (
          <SmartInput label='Partita IVA' name='company_vat' required />
        )}
      </FormGrid>

      <FormGroup>
        <SmartInput
          label="Descrizione attività dell'azienda (Massimo 100 caratteri)"
          name='company_activity'
          required
          maxLenght={100}
        />
      </FormGroup>

      <FormGrid cols={[4, 4, 4]}>
        <SmartInput
          label='Num. iscrizione C.C.I.A.A.'
          name='company_cciaa_nr'
        />

        <SmartDatePicker
          label='Data iscrizione C.C.I.A.A.'
          name='company_cciaa_date'
        />

        <SmartDatePicker
          label="Data inizio attività d'impresa"
          name='company_date_start'
        />
      </FormGrid>

      <FormGrid cols={[4, 4, 4]}>
        <SmartRadio
          label='Appartenente al regime fiscale minimo?'
          name='company_minimum_tax'
          options={[
            {
              label: 'No',
              value: false,
            },
            { label: 'Sì', value: true },
          ]}
        />
        <SmartRadio
          label='A regime IVA forfettario legge n° 398/91?'
          name='flat_rate_vat'
          options={[
            {
              label: 'No',
              value: false,
            },
            { label: 'Sì', value: true },
          ]}
        />
        <HelpBlock>
          <SmartInput
            label='Tipologia e % di ritenuta fiscale da applicare'
            name='company_withholding_tax'
          />
          <StyledTooltip
            shadow
            width='250px'
            content={<img src={InfoIcon} alt='info_icon'></img>}
            direction='left'
          >
            <Text variant='s14' color={themeEstra.color.primari.grigioEstra}>
              La ritenuta d&apos;acconto si applica ai liberi professionisti, in
              caso di prestazioni occasionali:{'\n'}È necessario pertanto
              specificare la percentuale.
            </Text>
          </StyledTooltip>
        </HelpBlock>
      </FormGrid>

      <FormGroup>
        <Text variant='s14' color={themeEstra.color.primari.grigioEstra}>
          Pur essendo Estra S.p.A. soggetta a regime di Split Payment, in virtù
          del vostro regime speciale IVA è richiesto un invio di regolare
          fattura senza alcuna modifica, esplicitando nelle eventuali fatture
          solo il regime fiscale agevolato a cui si è sottoposti.
        </Text>
      </FormGroup>
    </>
  )
}

const HelpBlock = styled.div`
  position: relative;
`

const StyledTooltip = styled(Tooltip)`
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
`
